import { Stack, Typography } from '@mui/material';

// The one empty message the shortlist surfaces use, wherever they have nothing to
// show: before a care expert has published anything, and on a published list that
// no provider has confirmed yet.
//
// It was two blocks with two treatments — an h1 on the care search page, an h3 on
// the waiting list — which read as two different products the moment you saw them
// side by side. h3 is the one that survived: h1 is the page-title size, and on a
// screen with no other heading it made the absence of content the loudest thing
// there.
//
// Copy comes from the caller. The layout is the shared part; what an empty screen
// says depends on why it is empty, and only the screen knows that. Where it sits
// is the caller's too, and both callers put it 80px below the chrome.
const ShortlistsEmptyState = ({
  title,
  body,
}: {
  title: string;
  body: string;
}) => (
  <Stack sx={{ textAlign: 'center', alignItems: 'center', px: 2 }} spacing={1}>
    <Typography variant='h3'>{title}</Typography>
    <Typography variant='body1' color='text.secondary'>
      {body}
    </Typography>
  </Stack>
);

export default ShortlistsEmptyState;
